// extracted by css-extract-rspack-plugin
export default {"input":"DrBYS","error":"N6V_A"};